import { Seniority } from '../types';

export const COMPANY_SIZE_ORDER = [
    '1 - 5 Kişi',
    '6 - 10 Kişi',
    '11 - 20 Kişi',
    '21 - 50 Kişi',
    '51 - 100 Kişi',
    '101 - 249 Kişi',
    '250+',
] as const;

export const SENIORITY_ORDER: Seniority[] = ['Junior', 'Middle', 'Senior'];

export const DATA_URLS = {
    salarySummary: '/yazilimcimaaslari/data/salary_summary.csv',
    positionExperience:
        '/yazilimcimaaslari/data/position_experience_salary_summary.csv',
    companySizeSeniority:
        '/yazilimcimaaslari/data/company_size_seniority_salary_summary.csv',
} as const;
